var React = require('react');

function DescTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M117.149 122.854L150.375 9.04713L238.143 173.858L117.149 122.854Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M15.3912 137.378L150.546 9.02188L117.313 122.666L15.3912 137.378Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M15.3945 137.38L117.245 122.678L238.144 173.859L15.3945 137.38Z","fill":"#5915C7","key":2})]);
}

DescTriangle.defaultProps = {"width":"196","height":"205","viewBox":"0 0 196 205","fill":"none"};

module.exports = DescTriangle;

DescTriangle.default = DescTriangle;
